<template>
  <div class="iv-footer">
    <div class="container-fluid text-right">
      <p class="iv-footer-text">
        Powered by
        <a :href="env.serverAddr">
          <img
            class="iv-logo"
            :src="env.staticAddr + '/ivgcs/img/logo-original.png'"
            alt="InitialView"
          >
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import env from '../utils/env.js'

export default {
  name: 'Footer',
  data() {
    return {
      env: env
    }
  }
}
</script>

<style scoped>
.iv-footer-text {
  margin: 0px;
}

.iv-logo {
  margin-bottom: 5px;
  height: 17.5px;
  width: auto;
}
</style>